import { isString } from 'lodash';

const VALID_DATE_REGEXP = /(19|20)\d{2}-\d{1,2}-\d{1,2}/;

export default function validateDate(date: any) {
  if (!date || !isString(date)) {
    return false;
  }

  return VALID_DATE_REGEXP.test(date);
}
